import React from "react";
export default function GotoTrangleSvg() {return <svg xmlns="http://www.w3.org/2000/svg" fill="none" width="8" height="8"><path d="M0 7.191a.5.5 0 0 0 .724.447l6.382-3.19a.5.5 0 0 0 0-.895L.724.362A.5.5 0 0 0 0 .809v6.382Z" fill="currentColor"/></svg>}
